module.exports = __webpack_public_path__ + "img/chinaunion.31875988.svg";